import React, { FC } from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import {
  FormLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  IconButton
} from '@mui/material';
import { ExpandMore, Restore } from '@mui/icons-material';
import { IBuild } from '../../../models';

interface IMobileManageSpec {
  original: IBuild;
  handleReset: (val: IBuild) => void;
}

export const MobileManageSpec: FC<IMobileManageSpec> = ({ original, handleReset }) => {
  const classes = useStyles();
  const { neighborhood, lotNumber, status, buyer, agents } = original;

  return (
    <Accordion className={classes.root}>
      <AccordionSummary
        className={classes.accordion}
        expandIcon={<ExpandMore />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <div className={classes.topPanelSummaryWrapper}>
          <Typography variant="body2">
            {neighborhood} - Lot {lotNumber}
          </Typography>
          <div className={classes.buttonsWrapper}>
            <IconButton
              className={classes.editButton}
              color="primary"
              onClick={e => {
                e.stopPropagation();
                handleReset(original);
              }}
              size="large"
            >
              <Restore />
            </IconButton>
          </div>
        </div>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Neighborhood:
          </FormLabel>
          <Typography component="span" variant="body2">
            {neighborhood || '--'}
          </Typography>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Lot:
          </FormLabel>
          <Typography component="span" variant="body2">
            {lotNumber || '--'}
          </Typography>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Agents:
          </FormLabel>
          <Typography component="span" variant="body2">
            {agents &&
              agents.length > 0 &&
              agents.map((agent, index) => {
                return (
                  <span key={`${index}`}>
                    {agent.firstName} {agent.lastName}
                    {index !== original.agents.length - 1 ? ', ' : ''}
                  </span>
                );
              })}
          </Typography>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Buyer:
          </FormLabel>
          <Typography component="span" variant="body2">
            {buyer || '--'}
          </Typography>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Phase:
          </FormLabel>
          <Typography component="span" variant="body2">
            {status || '--'}
          </Typography>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: '100%',
    border: `1px solid ${theme.palette.grey[300]}`,
    overflowX: 'hidden'
  },
  accordion: {
    padding: '0 16px',
    '&& .MuiAccordionSummary-expandIcon': {
      padding: 3
    }
  },
  topPanelSummaryWrapper: {
    marginTop: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    '&:first-child': { marginTop: 0 }
  },
  panelSummaryWrapper: {
    '&:first-child': { marginTop: 0 }
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    padding: '12px 16px',
    backgroundColor: theme.palette.grey[100]
  },
  roleWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  editButton: {
    padding: `2px 5px`
  },
  deleteButton: {
    padding: `2px 5px`,
    color: theme.palette.error.main
  },
  boldName: {
    color: theme.palette.primary.main,
    fontWeight: 600
  },
  subLabel: {
    marginRight: 10,
    fontSize: theme.typography.body2.fontSize,
    color: theme.palette.typography.labels
  },
  buttonsWrapper: {
    display: 'flex'
  }
}));
